import React, { Component } from 'react';
import UtilService from "../../services/util.service";
import ChatBotApiService from '../../services/chatbot-api.service';
import ShowPDF from '../unused-components/show-pdf-component'
import { static_links } from "../../constants/static_links";
import PlatformType from "../../enums/PlatformType"
import GlobalStoreService from '../../services/global-store.service';
import { SCRIPTS } from "../../constants/staticScripts";


const DuplicateBills = ({ message, showPopup, template_name, handleUserAction, messageTime }) => {

    let data = message
    let bills
    try {
        data = JSON.parse(data)
        bills = JSON.parse(data['bills_string'])
    }
    catch (e) {
        data = undefined
    }

    const viewBillClick = (bill) => {
        let reqData = {
            "invoiceNumber": bill.invoiceNumber,
            "billAccountNumber": bill.billAccountNumber,
            "authToken": data.authToken,
            "transactionId": data.transactionId
        }

        if (GlobalStoreService.get("APP_CONTEXT")) {
            //ADD DEEP LINK FOR APP

            let billDeepLink = static_links.duplicate_bills[GlobalStoreService.get('platformType')]

            billDeepLink = UtilService.replaceAll(
                billDeepLink,
                "{mobile}",
                GlobalStoreService.get('currentNumber')
            );

            window.open(billDeepLink)
        }
        else {

            ChatBotApiService.getPostPaidBill(reqData).then((res) => {

                let linkSource = `data:application/pdf;base64,${res}`;
                const downloadLink = document.createElement("a");
                const fileName = `bill_${bill.invoiceNumber}.pdf`;
                downloadLink.download = fileName
                downloadLink.href = linkSource
                downloadLink.click();


            }).catch((err) => {
                console.log('get bill err', err)
            })
        }
    }


    return (
        <div id={`plans_scroll_${messageTime.timestamp}`} style={{ alignItems: 'center', display: 'flex' }} className={`monthly-plan monthly-plan-scroll ${(false && bills && bills.length > 1) ? 'pl-10' : 'monthly-plan-single pl-67'}`} >
            {!bills && <ul className="bubbles relate pl-67 relate-0" ><li><p>{SCRIPTS.NO_SYSTEM_INFO_MESSAGE}</p></li></ul>}
            {(UtilService.getPlatformType() === PlatformType.WEB) && bills && bills.length > 0 && <div className="carousel_web_arrows">
                <div><button className="arrow_button_left"
                    onClick={() => {
                        UtilService.startScrollingLeft(`plans_scroll_${messageTime.timestamp}`);
                    }}
                >&#8249;</button></div>
                <div><button className="arrow_button_right"
                    onClick={() => {
                        UtilService.startScrollingRight(`plans_scroll_${messageTime.timestamp}`);
                    }}
                >&#8250;</button></div>
            </div>}
            {bills && bills.length > 0 && <ul className="carousel_list">
                {bills && bills.map((bill, index) => {
                    return (
                        <li key={index} className="monthly_plan_item">
                            <div
                                className=" plan-details color-black" style={{ height: '200px' }}>
                                <span className="fs-8 display-block color-grey pl-10  pt-15">BILL</span>

                                <span className="fs-20 display-block color-dark-grey  pl-10">Rs. {bill.monthlyCharges}</span>
                                <span className="line" />
                                <ul className="benifits">
                                    <li >{'Bill Date '}<br></br>{bill.billDate}</li>
                                    <li>{'Invoice Number '}{bill.invoiceNumber}</li>
                                    <li >{'Account Number '}{bill.billAccountNumber}</li>

                                </ul>
                                <button onClick={() => {
                                    viewBillClick(bill)
                                }}
                                    className=" cursor-pointer billplan-card-links color-link fs-12 display-block  activate">DOWNLOAD</button>
                            </div>
                        </li>
                    )
                })}

            </ul>}
            {bills && bills.length === 0 && <ul className="bubbles relate pl-67 relate-0" ><li><p>{SCRIPTS.NO_BILLS}</p></li></ul>}
        </div>
    );
}

export default DuplicateBills;


// WEBPACK FOOTER //
// ./src/components/message-components/duplicate-bills.component.js